import { CampaignSubSource } from 'utils/constants/campaign';

import createReducer, { ActionCreatorHelper } from 'store/createReducer';

type IsVisible = boolean;

export interface AccountInfo {
    clientId: string;
    displayName: string;
    link: string;
}

export interface SourceAccountData {
    apiSource: CampaignSubSource;
    accountsInfo: AccountInfo[];
}

// ----------------------- actions -------------------------------------
const SET_VISIBLE_SOURCE_ACCOUNTS = 'SET_VISIBLE_SOURCE_ACCOUNTS';
const SET_DATA_SOURCE_ACCOUNTS = 'SET_DATA_SOURCE_ACCOUNTS';

interface PayloadTypes {
    [SET_VISIBLE_SOURCE_ACCOUNTS]: IsVisible;
    [SET_DATA_SOURCE_ACCOUNTS]: SourceAccountData[];
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setVisibleSourceAccounts = ActionCreator(SET_VISIBLE_SOURCE_ACCOUNTS);
export const setDataSourceAccounts = ActionCreator(SET_DATA_SOURCE_ACCOUNTS);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface SourceAccountsState {
    isVisible: IsVisible;
    sourceAccountsData: SourceAccountData[];
}

const SOURCE_ACCOUNTS_INITIAL_STATE: SourceAccountsState = {
    isVisible: false,
    sourceAccountsData: [],
};

export default createReducer<SourceAccountsState, PayloadTypes>(SOURCE_ACCOUNTS_INITIAL_STATE, {
    [SET_VISIBLE_SOURCE_ACCOUNTS]: (state, { payload }) => ({
        ...state,
        isVisible: payload,
    }),
    [SET_DATA_SOURCE_ACCOUNTS]: (state, { payload }) => ({
        ...state,
        sourceAccountsData: payload,
    }),
});
// ----------------------- /reducer --------------------------------------
